export default "__VITE_ASSET__BndvWSZ4__"